import type { TrackEvent } from "src/state/Track/TrackCubit";

export default function createTrackEvent(str: string): TrackEvent {
  let clean = str;

  clean = clean.trim();

  return clean as unknown as TrackEvent;
}
